import { createAsyncThunk } from '@reduxjs/toolkit';
import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey:
    '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',
  dangerouslyAllowBrowser: true,
});

const promptUser =
  'Please give me an answer with a description of what language the code is written in, briefly what the code is about and rate it from 0 to 100 and write it down in the score. Tell me how it can be improved and give an example of improved code. Here is the code that needs to be evaluated:  ';

export const sendMessageThunk = createAsyncThunk(
  'sendMessage',
  async (sendMessage, thunkAPI) => {
    const content = promptUser + sendMessage;
    try {
      const completion = await openai.chat.completions.create({
        model: 'gpt-4o-mini',
        messages: [
          { role: 'system', content: 'You are a helpful assistant.' },
          {
            role: 'user',
            content,
          },
        ],
      });

      return completion.choices[0].message.content;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
